import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Menu } from 'features/shared/Menu'
import { Flex } from 'components/Flex'
import { Text } from 'components/Text'
import { Logo } from 'features/shared/Logo'
import styles from './Layout.module.scss'

export const Layout: FC = ({ children }) => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <div className={styles.brand}>
          <Link to="/dashboard">
            <Logo />
          </Link>
        </div>
        <div className={styles.menuWrapper}>
          <Menu />
        </div>
      </header>
      <div className={styles.content}>{children}</div>
      <footer className={styles.footer}>
        <Flex justify="between" align="center">
          <Text>
            Descifra © {currentYear} {t('common.copyright')}
          </Text>
          <div>
            <Link to="/privacy-policy">
              <Text component="span">{t('common.privacy_policy')}</Text>
            </Link>
            <Link to="/terms-and-conditions">
              <Text component="span">{t('common.tos')}</Text>
            </Link>
          </div>
        </Flex>
      </footer>
    </div>
  )
}

Layout.displayName = 'Layout'
